import React from 'react';
import './Keywords.css';

const Keywords = () => {
    const keywords = [
        'ونش انقاذ 6 اكتوبر',
        'ونش انقاذ التجمع',
        'ونش انقاذ التجمع الخامس',
        'نقل سيارات معطلة',
        'ونش إنقاذ الجيزة',
        'خدمات طوارئ الطريق',
        'تغيير إطارات',
        'وصلة بطارية',
        'ونش إنقاذ الإسكندرية',
        'نقل معدات ثقيلة',
        'ونش إنقاذ سريع',
        'إنقاذ سيارات مصر',
        'خدمة ونش إنقاذ احترافية',
        'نقل كرفانات',
        'ونش إنقاذ طرق سريعة',
        'توصيل وقود',
        'ونش حوادث',
        'خدمات ونش إنقاذ رخيصة',
        'ونش إنقاذ الطريق الصحراوي',
        'نقل سيارات فاخرة',
        'ونش إنقاذ شاحنات',
        'خدمات طوارئ سيارات',
        'ونش إنقاذ الساحل الشمالي',
        'إصلاح سيارات على الطريق',
        'ونش إنقاذ العاصمة الإدارية',
        'نقل سيارات آمن',
        'ونش انقاذ مرسي مطروح',
        'خدمات ونش موثوقة',
        'ونش إنقاذ الشيخ زايد',
        'إنقاذ سيارات عالقة',

        // التجمع
        'ونش انقاذ التجمع الاول',
        'ونش انقاذ التجمع التالت',
        'ونش التجمع',
        'ونش التجمع الخامس',
        'ونش التجمع الاول',
        'ونش التجمع التالت',

        // القاهرة الجديدة والمناطق
        'ونش انقاذ مدينه نصر',
        'ونش انقاذ مصر الجديده',
        'ونش مدينه نصر',
        'ونش مصر الجديده',
        'ونش انقاذ المقطم',
        'ونش المقطم',
        'ونش الشروق',
        'ونش انقاذ الشروق',
        'ونش انقاذ بدر',
        'ونش بدر',
        'ونش انقاذ العبور',
        'ونش العبور',
        'ونش انقاذ الرحاب',
        'ونش الرحاب',
        'ونش انقاذ مدينتي',
        'ونش مدينتي',

        // كلمات تسويقية إضافية
        'اسرع ونش انقاذ',
        'افضل ونش انقاذ',
        'ارخص ونش انقاذ',
        'ونش انقاذ 24 ساعة',
        'ونش انقاذ قريب مني',
        'ونش انقاذ سيارات',
        'ونش سحب سيارات',
        'ونش انقاذ للطوارئ',
        'ونش انقاذ فوري',
        'ونش انقاذ على الطريق',
        'ونش انقاذ معطلين',
        'ونش انقاذ محترف',
        'ونش انقاذ متنقل',
        'خدمة ونش انقاذ سريعة',
        'ونش انقاذ بأسعار رخيصة',
        'ونش انقاذ لجميع السيارات',
        'ونش انقاذ داخل القاهرة',
        'ونش انقاذ خارج القاهرة',
        'ونش انقاذ الطرق السريعة',
        'ونش انقاذ للحوادث'
    ];

    return (
        <section className="keywords-section">
            <div className="keywords-container">
                <div className="keywords-header">
                    <h3 className="keywords-subtitle">ابحث عن خدماتنا</h3>
                    <h2 className="keywords-title">
                        كلمات <span className="highlight">بحث ذات صلة</span>
                    </h2>
                    <div className="keywords-divider">
                        <span className="star">★</span>
                        <span className="star">★</span>
                        <span className="star">★</span>
                        <span className="star">★</span>
                    </div>
                </div>

                <div className="keywords-cloud">
                    {keywords.map((keyword, index) => (
                        <span key={index} className="keyword-tag">
                            {keyword}
                        </span>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Keywords;

